import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CheckCalibragemService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getChecksCalibragem(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkcalibragem' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckCalibragem(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkcalibragem/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckCalibragemByUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkcalibragem/unidade/' + unidade_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckCalibragemByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkcalibragem/usuario/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckCalibragemByRegiao(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkcalibragem/regiao/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCheckCalibragem(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checkcalibragem', {
			usuario_id:  data.usuario_id,
			check_calibragem_data:  data.check_calibragem_data,
			check_calibragem_turno:  data.check_calibragem_turno,
			cliente_id:  data.cliente_id,
			unidade_id:  data.unidade_id,
			profissional_id:  data.profissional_id,
			veiculo_id:  data.veiculo_id,
			check_calibragem_ed_pressao: data.check_calibragem_ed_pressao,
			check_calibragem_ed_dot: data.check_calibragem_ed_dot,
			check_calibragem_et_pressao: data.check_calibragem_et_pressao,
			check_calibragem_et_dot: data.check_calibragem_et_dot,
			check_calibragem_dd_pressao: data.check_calibragem_dd_pressao,
			check_calibragem_dd_dot: data.check_calibragem_dd_dot,
			check_calibragem_dt_pressao: data.check_calibragem_dt_pressao,
			check_calibragem_dt_dot: data.check_calibragem_dt_dot,
			check_calibragem_registro: data.check_calibragem_registro,

			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCheckCalibragem(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/checkcalibragem/' + data.check_calibragem_id, {
				check_calibragem_id:  data.check_calibragem_id,
				usuario_id:  data.usuario_id,
				check_calibragem_data:  data.check_calibragem_data,
				check_calibragem_turno:  data.check_calibragem_turno,
				cliente_id:  data.cliente_id,
				unidade_id:  data.unidade_id,
				profissional_id:  data.profissional_id,
				veiculo_id:  data.veiculo_id,
				check_calibragem_ed_pressao: data.check_calibragem_ed_pressao,
				check_calibragem_ed_dot: data.check_calibragem_ed_dot,
				check_calibragem_et_pressao: data.check_calibragem_et_pressao,
				check_calibragem_et_dot: data.check_calibragem_et_dot,
				check_calibragem_dd_pressao: data.check_calibragem_dd_pressao,
				check_calibragem_dd_dot: data.check_calibragem_dd_dot,
				check_calibragem_dt_pressao: data.check_calibragem_dt_pressao,
				check_calibragem_dt_dot: data.check_calibragem_dt_dot,
				check_calibragem_registro: data.check_calibragem_registro,

			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckCalibragem(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkcalibragem/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckCalibragemAdmin(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkcalibragem/admin/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}

